import {popupCreateUpdateService, popupCreateUpdateServiceCategory} from "../common/PopupForms";

export default function tableSettingsServicesCategories(HelperTable) {

    const selectorTable = '#table-services-category';
    const elTable = $(selectorTable)

    if (!elTable?.length) {
        return;
    }

    const tableData = Object.entries(ESR.services_terms).map(item => item[1])


    const columns = [
        {
            label: ESR.lang.id,
            data: 'term_id',
            orderable: true
        },
        {
            label: ESR.lang.category_name,
            data: 'term_name',
            orderable: true
        },
        {
            label: ESR.lang.visibility,
            data: 'visibility',
            render: function (data, type, row) {
                const value = row.visibility !== 'false'
                if (type === 'display') {
                    return value ? ESR.lang.visible : ESR.lang.hidden;
                } else if (type === 'filter') {
                    return value;
                }
                return data;
            }
        },
    ];

    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)

    const toolbar = HelperTable.createToolbarButtons({
        btnAdd: true,
        btnEdit: true,
        btnDelete: false,
    })

    let btnAdd = toolbar.find('.btn-row-add')
    let btnRowEdit = toolbar.find('.btn-row-edit')

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: tableData,
        columns: columns,
        // stateSave: true,
        order: [
            [0, 'dsc']
        ],
        pageLength: 50,
        processing: false,
        serverSide: false,
        info: false,
        layout: {
            topStart: toolbar,
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
            bottom: 'paging',
            bottomStart: null,
            bottomEnd: null
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
        },
        rowCallback: function(row, data) {
            if( data.visibility === 'false' ){
                $(row).addClass('opacity-70');
            }
        },
        initComplete: function () {
            const api = this.api();
            const state = api.state.loaded()


            const colStatusIndex = 2;
            const colStatus = api.column(colStatusIndex);
            const colStatusStateValue = state?.columns[colStatusIndex].search.search ?? '';
            const elSelectStatus = ESR.View.select({
                value: colStatusStateValue,
                class: 'select-vizibility select-sm',
                placeholder: ESR.lang.visibility,
                options: [
                    {value: 'true', label: ESR.lang.visible},
                    {value: 'false', label: ESR.lang.hidden}
                ]
            }).on('change', function () {
                colStatus.search($(this).val(), {exact: true}).draw();
            });

            if(colStatusStateValue) {
                colStatus.search(colStatusStateValue, {exact: true}).draw();
            }

            $('.dt-layout-end').prepend(elSelectStatus)
        }
    });


    if (btnAdd.length) {
        // Handle add new project button click
        btnAdd.click((e) => {
            e.preventDefault();
            popupCreateUpdateServiceCategory({}, ESR.lang.add);
        });

        $('body').on('click', (e) => {
            HelperTable.onSelectRow(e, table, btnRowEdit)
        });
    }

    // Handle row edit button click
    if (btnRowEdit.length) {
        btnRowEdit.click((e) => {
            e.preventDefault();
            const elRow = table.row('.selected');
            if (!elRow.node()) {
                return;
            }
            popupCreateUpdateServiceCategory(elRow.data(), ESR.lang.save);
        });
    }

}